var _path, _path2, _path3, _path4, _g, _path5, _g2, _path6, _g3, _path7, _g4, _path8, _g5, _path9, _g6, _path10, _g7, _path11, _g8, _path12, _g9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnthropic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Anthropic_svg__clip0_8511_31803)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Anthropic_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 133,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.5.03H.381v14.68H132.5V.03z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Anthropic_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Anthropic_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 133,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.375.034h132.119v14.68H.375V.034z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Anthropic_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Anthropic_svg__c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 133,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.372.039h132.119v14.68H.372V.039z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Anthropic_svg__c)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Anthropic_svg__d",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 133,
    height: 15
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M.37.044h132.118v14.68H.37V.043z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Anthropic_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.175 10.21L20.745.275h-3.471v14.193h2.96V4.533l6.43 9.935h3.47V.275h-2.96v9.935z",
    fill: "#444"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Anthropic_svg__e",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 133,
    height: 15
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M.37.044h132.118v14.68H.37V.043z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Anthropic_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.582 3.012h4.798v11.456h3.062V3.012h4.798V.275H32.582v2.737z",
    fill: "#444"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Anthropic_svg__f",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 133,
    height: 15
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M.37.044h132.118v14.68H.37V.043z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Anthropic_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.5 5.932h-6.737V.275h-3.062v14.193h3.062V8.669H57.5v5.799h3.062V.275H57.5v5.657z",
    fill: "#444"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Anthropic_svg__g",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 133,
    height: 15
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M.37.044h132.118v14.68H.37V.043z",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Anthropic_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.387 3.012h3.777c1.511 0 2.308.548 2.308 1.582s-.797 1.581-2.308 1.581h-3.777V3.012zm9.147 1.582c0-2.677-1.98-4.319-5.227-4.319h-6.983v14.193h3.063V8.913h3.41l3.063 5.555h3.39L73.857 8.49c1.702-.65 2.676-2.018 2.676-3.895z",
    fill: "#444"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Anthropic_svg__h",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 133,
    height: 15
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M.37.044h132.118v14.68H.37V.043z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Anthropic_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.932 11.889c-2.409 0-3.879-1.703-3.879-4.481 0-2.818 1.47-4.521 3.879-4.521 2.388 0 3.837 1.703 3.837 4.521 0 2.778-1.449 4.48-3.837 4.48zm0-11.841c-4.123 0-7.042 3.041-7.042 7.36 0 4.278 2.919 7.32 7.042 7.32 4.103 0 7.001-3.042 7.001-7.32 0-4.319-2.898-7.36-7.001-7.36z",
    fill: "#444"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Anthropic_svg__i",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 133,
    height: 15
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M.37.044h132.118v14.68H.37V.043z",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Anthropic_svg__i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.625 6.58h-3.779V3.013h3.779c1.511 0 2.308.608 2.308 1.784 0 1.176-.797 1.785-2.308 1.785zm.143-6.305h-6.986v14.193h3.064v-5.15h3.922c3.247 0 5.228-1.703 5.228-4.522 0-2.818-1.981-4.521-5.228-4.521z",
    fill: "#444"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Anthropic_svg__j",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 133,
    height: 15
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M.37.044h132.118v14.68H.37V.043z",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Anthropic_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.729 9.719c-.53 1.378-1.592 2.17-3.041 2.17-2.409 0-3.879-1.704-3.879-4.482 0-2.818 1.47-4.521 3.879-4.521 1.449 0 2.511.79 3.041 2.17h3.246c-.796-3.042-3.184-5.009-6.287-5.009-4.124 0-7.043 3.041-7.043 7.36 0 4.278 2.919 7.32 7.043 7.32 3.123 0 5.511-1.987 6.307-5.008h-3.266z",
    fill: "#444"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Anthropic_svg__k",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 133,
    height: 15
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M.37.044h132.118v14.68H.37V.043z",
    fill: "#fff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Anthropic_svg__k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.231.275l5.699 14.193h3.125L112.356.275h-3.125z",
    fill: "#444"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "Anthropic_svg__l",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 133,
    height: 15
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M.37.044h132.118v14.68H.37V.043z",
    fill: "#fff"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Anthropic_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.74 8.851l1.95-4.987L9.64 8.85h-3.9zM6.056.275L.36 14.468h3.186l1.165-2.98h5.96l1.166 2.98h3.185L9.324.275H6.056z",
    fill: "#444"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Anthropic_svg__clip0_8511_31803"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.393)",
    d: "M0 0h132.119v14.68H0z"
  })))));
}
export default __webpack_public_path__ + "assets/static/media/Anthropic.2c92b339.svg";
export { SvgAnthropic as ReactComponent };